module.exports = new __parcel__URL__("vr-reparent-onboarding-dark.b792df5b.svg").toString();